import React, { FC } from 'react'

const ContentWrapper: FC = (props) => {
  const { children } = props
  return (
    <div className="max-w-[1100px] flex-1 flex flex-col mx-auto rounded-2 border-1 border-gray-extra-light">
      {children}
    </div>
  )
}

export default ContentWrapper
